// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMessageTime-moduletime___JYkg";
export { _1 as "time" }
